/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class OnboardAzureSourceAccountInteractive200Response {
  'status'?: string;
  'message'?: string;
  /**
  * Request ID for tracking the onboarding status
  */
  'requestId'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "status",
      "baseName": "status",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "message",
      "baseName": "message",
      "type": "string",
      "format": "tobedefined"
    },
    {
      "name": "requestId",
      "baseName": "requestId",
      "type": "string",
      "format": "uuid"
    }  ];

  static getAttributeTypeMap() {
    return OnboardAzureSourceAccountInteractive200Response.attributeTypeMap;
  }

  public constructor() {
  }
}

